import React from 'react';

import ReactionTriggers from './ReactionTriggers';

import { Socket, Event, User } from 'Services';
import {asset} from 'Services/BaseHelpers';

export default class Reactions extends React.Component {
    /**
     * @var limit
     * @type {integer}
     */
    limit = 25;

    /**
     * @var state
     * @type {{emojis: [], reactionDisabled: boolean}}
     */
    state = {
        reactions: [],
        fullscreen: false,
    };

    /**
     * @var containerRef
     * @type {null}
     */
    containerRef = null;

    /**
     * @var animateInterval
     * @type {null}
     */
    animateInterval = null;

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        this.connectToBroadcasts();

        this.animateInterval = setInterval(this.animateReactions, 100);

        Event.on('fullscreen', (fullscreen) => {
            this.setState({
                fullscreen,
            });
        });

        Event.on('reaction-posted', (reaction) => {
            this.handleAddReaction(reaction);
        });
    };

    /**
     * @method connectToBroadcasts
     */
    connectToBroadcasts = () => {
        Socket.getConnection()
            .private(`main_stage_reactions.${this.props.sessionId}`)
            .listen('MainStageReaction', (e) => {
                if (e.reaction.user_id !== User.id) {
                    this.handleAddReaction(e.reaction);
                }
            });
    };

    /**
     * @method componentWillUnmount
     */
    componentWillUnmount = () => {
        Socket.getConnection().leave(`main_stage_reactions.${this.props.sessionId}`);
    };

    /**
     * @method animateReactions
     */
    animateReactions = () => {
        if (this.state.reactions.length === 0) {
            return;
        }

        let { reactions } = this.state;

        reactions = reactions.map((e) => {
            e.pos.left += e.step;
            let top = e.pos.top;

            if (e.fluctuation.direction === 'upper') {
                top += 1;

                if (top >= e.fluctuation.upper) {
                    e.fluctuation.direction = 'lower';
                }
            } else {
                top -= 1;

                if (top <= e.fluctuation.lower) {
                    e.fluctuation.direction = 'upper';
                }
            }
            e.pos.top = top;

            return e;
        });

        reactions = reactions.filter(e => e.pos.left < this.containerRef.clientWidth + 30);

        this.setState({
            reactions,
        });
    };

    /**
     * @method handleAddReaction
     * @param {object} reaction
     */
    handleAddReaction = (reaction) => {
        let { reactions } = this.state;

        let top = Math.round(Math.random(0, 1) * 60);
        top = top < 5 ? 5 : top;

        const step = Math.round(Math.random(0, 1) * 5) + 5; // Between 5 and 10

        reactions.push({
            id: reaction.id,
            type: reaction.reaction,
            step,
            fluctuation: {
                upper: top + 5,
                lower: top - 5,
                direction: 'upper',
            },
            pos: {
                top,
                left: 0,
            },
        });

        if (reactions.length > this.limit) {
            reactions.shift();
        }

        this.setState({
            reactions,
        });
    };

    /**
     * @method renderReaction
     * @param {object} reaction
     * @return {JSX.Element}
     */
    renderReaction = (reaction) => {
        let top = reaction.pos.top * (this.containerRef.clientHeight / 100);

        if (top > (this.containerRef.clientHeight - 30)) {
            top = this.containerRef.clientHeight - 30;
        }

        return (
            <img
                key={reaction.id}
                src={asset(`/images/reactions/${reaction.type}.png`)}
                alt={reaction.type}
                className="absolute w-8 h-8 transition-all duration-200"
                style={{
                    ...reaction.pos,
                    top,
                }}
            />
        );
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const { children, side } = this.props;
        const { reactions, fullscreen } = this.state;

        return (
            <div className="relative w-full">
                {children}

                <div ref={ref => this.containerRef = ref}
                     className="h-1/3 absolute left-0 right-0 bottom-0 pointer-events-none overflow-hidden">
                    {reactions.map(this.renderReaction)}
                </div>

                <div className={
                    `absolute ${side}-0 top-0 bottom-10 flex justify-center flex-col right-10 ${fullscreen ? (side === 'left' ? 'ml-6' : 'mr-6') : (side === 'left' ? '-ml-6' : '-mr-6')}`
                }>
                    <ReactionTriggers
                        sessionId={this.props.sessionId}
                    />
                </div>
            </div>
        );
    };
}
